<template>
  <div>
    <v-container class="px-6">
      <v-row class="d-flex align-center px-3 mb-1">
        <div>
          <h1>Pagamento</h1>
          <p>Visualize os dados do pagamento</p>
          
        </div>
        <v-spacer />
        <v-tooltip :disabled="canConcluirPagamento || canPublicarPagamento" bottom>
          <template v-slot:activator="{ on, attrs }">
            <span v-on="on" v-bind="attrs">
              <v-btn
                v-if="isStatusCliente && !isUsuarioTradimus"
                @click="openConclusaoDialog"
                :disabled="!canConcluirPagamento"
                class="mr-2"
                color="primary"
                outlined
              >
                Concluir
              </v-btn>
              <v-btn
                v-if="!isStatusCliente && isUsuarioTradimus"
                @click="handlePublicarPagamentoClick"
                :disabled="!canPublicarPagamento"
                class="mr-2"
                color="primary"
                outlined
              >
                Publicar
              </v-btn>
            </span>
          </template>
          <span v-if="!statusPublicacaoPendente">Finalize a conciliação de todos os lotes para concluir o pagamento</span>
          <span v-else-if="percentuaisInconsistentes">Existe Lote, Guia ou item com % de conciliação acima de 100%, solicitar correção para equipe técnica</span>
        </v-tooltip>
        <PagamentoActions
          v-if="getPagamentoById"
          :pagamentoId="pagamentoId"
          :pagamentoStatus="getPagamentoById.status"
          :baixaDisabled="baixaDisabled"
          @encerrarValidacaoClick="handleEncerrarValidacaoClick"
          @baixarPlanilhaClick="handleBaixarPlanilhaClick"
          @navigateToBaixa="handleNavigateToBaixa"
          @updateToFaturamentoNaoIdentificadoClick="handleUpdateToFaturamentoNaoIdentificadoClick"
          @updateToValoresDivergentesClick="handleUpdateToValoresDivergentesClick"
      />
      </v-row>
      <InformacoesPagamento
        v-if="getPagamentoById"
        :pagamento="getPagamentoById"
        :show-valor-pendente="false"
        @quitarPagamentoClick="handleQuitarPagamentoClick"
      />
      <div v-if="selectedLotes.length === 0" class="d-flex align-center pt-6">
        <div>
          <p class="mb-0">Ordernar por</p>
          <v-select
            v-model="selectSort"
            :label="selectSort"
            :items="sortOptions"
            item-text="text"
            item-value="value"
            hide-details
            flat
            solo
            outlined
            dense
          />
        </div>
        <v-spacer />
        <FiltroPagamento
          :pagamentoId="pagamentoId"
          @clearFilter="handleClearFilter"
          @changeFilter="handleChangeFilter"
        />
      </div>
      <div v-else class="pt-6">
        <LoteActions
          :selectedLotes="selectedLotes"
          :totalLotes="totalLotes"
          :canDoActions="canDoActions"
          @selectAllLotes="selectAllLotes"
          @deselectAllLotes="deselectAllLotes"
          @conciliacaoAutomatica="handleConciliacaoAutomaticaBatchClick"
          @desconciliar="handleDesconciliar"
          @conciliacaoManual="handleIniciarConciliacoesManuais"
          @assumirLotes="handleAssumir"
          @limparResponsavel="handleLimparResponsavel"
          @finalizarConciliacao="handleFinalizarConciliacao"
        />
      </div>
      <div class="d-flex">
        <LotesTabs
          :tabs="tabs"
          :selectedTabKey="selectedTabKey"
          @tabChange="handleTabChange"
        />
        <div v-if="selectedLotes.length === 0">
          <v-menu offset-x offset-y left nudge-right="100">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="primary"
                v-bind="attrs"
                v-on="on"
                outlined
              >
                Ações de lotes
              </v-btn>
            </template>
            <v-list>
              <v-list-item
                v-for="(item, index) in acoesDeLotes"
                @click="item.onClick(true)"
                :key="index"
              >
                <v-list-item-title>{{ item.title }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>
      </div>
      <v-progress-linear v-if="$asyncComputed.getPagamentoLotesPage.updating" indeterminate />
      <div
        v-else-if="getPagamentoLotesPage.data.length == 0"
        class="text-center"
      >
        Nenhum lote foi encontrado
      </div>
      <template v-else>
        <v-pagination
          v-if="hasPagination"
          v-model="page"
          class="my-4"
          :length="paginationLength"
          :total-visible="7"
        />
        <ListaLotes
          :isUsuarioTradimus="isUsuarioTradimus"
          :lotes="getPagamentoLotesPage.data"
          :selectedLotes="selectedLotes"
          :isStatusCliente="isStatusCliente"
          :canDoActions="canDoActions"
          @selectLote="handleSelectLote"
          @deselectLote="handleDeselectLote"
        />
        <v-pagination
          v-if="hasPagination"
          v-model="page"
          class="my-4"
          :length="paginationLength"
          :total-visible="7"
        ></v-pagination>
      </template>
      <div v-if="usuarioTradimus">
        <h2 class="pb-6">Arquivos</h2>
        <v-progress-linear v-if="$asyncComputed.getPagamentoArquivosPage.updating" indeterminate />
        <TabelaDeArquivos
          v-else
          :arquivos="getPagamentoArquivosPage.data"
        />
      </div>
      <h2 class="py-6" id="comentarios">Comentários</h2>
      <ComentariosPagamento :pagamentoId="pagamentoId" />
    </v-container>
  </div>
</template>

<script>
import InformacoesPagamento from './pagamento/InformacoesPagamento.vue'
import ListaLotes from './pagamento/ListaLotes.vue'
import { conciliacaoClient } from '../../libs/conciliacao-client'
import TabelaDeArquivos from './pagamento/TabelaDeArquivos.vue'
import PagamentoActions from './pagamento/PagamentoActions.vue'
import LoteActions from './pagamento/LoteActions.vue'
import FiltroPagamento from './pagamento/FiltroPagamento.vue'
import { pagamentoLoteStatusLabels } from '../../libs/pagamento-lote-status-labels'
import { pagamentoStatusTradimus } from '../../libs/pagamento-status-tradimus'
import ComentariosPagamento from './pagamento/ComentariosPagamento.vue'
import LotesTabs from './pagamento/LotesTabs.vue'
import { sessionStorageClient } from '../../libs'

export default {
  components: {
    InformacoesPagamento,
    ListaLotes,
    TabelaDeArquivos,
    PagamentoActions,
    LoteActions,
    FiltroPagamento,
    ComentariosPagamento,
    LotesTabs
},
  props: {
    pagamentoId: String
  },
  data() {
    return {
      userId: null,
      pagamentoLoteStatusLabels,
      pagamentoStatusTradimus,
      page: 1,
      filterOptions: {
        status: '',
        numeroLote: '',
        numeroProtocolo: '',
        statusIn: [ 'conciliacaoManual', 'conciliacaoAutomatica' ],
        tab: {
           statusIn: [ 'conciliacaoManual', 'conciliacaoAutomatica' ]
        }
      },
      selectSort: 'Selecione',
      selectedLotes: [],
      sortOptions: [
        {
          text: 'Selecione',
          value: ''
        },
        {
          text: 'Datas mais recente',
          value: '-dataProtocolo'
        },
        {
          text: 'Datas mais antigas',
          value: 'dataProtocolo'
        },
        {
          text: 'Maiores valores informado',
          value: '-valorInformado'
        },
        {
          text: 'Menores valores informado',
          value: 'valorInformado'
        },
        {
          text: 'Maior índice de conciliação',
          value: ['-PercentualConciliadoValorAutomatico', '-PercentualConciliadoValorManual']
        },
        {
          text: 'Menor índice de conciliação',
          value: ['PercentualConciliadoValorAutomatico', 'PercentualConciliadoValorManual']
        }
      ],
      statusCount: {},
      tabs: [
        {
          label: 'Todos',
          key: null,
          query: { statusIn: undefined, isResponsavel: undefined }
        },
        {
          label: 'Responsável',
          key: 'responsavel',
          query: { isResponsavel: true }
        },
        {
          label: 'Pendente',
          key: 'statusPendente',
          query: { statusIn: [ 'conciliacaoManual', 'conciliacaoAutomatica' ], isResponsavel: undefined }
        },
        {
          label: 'Finalizados',
          key: 'statusFinalizado',
          query: { statusIn: [ 'conciliado', 'conciliadoParcialmente', 'naoConciliado' ], isResponsavel: undefined }
        }
      ],
      selectedTabKey: 'statusPendente',
      usuarioTradimus: false
    }
  },
  methods: {
    async handleConciliacaoAutomaticaBatchClick (isTodosOsLotes) {
      try {
        console.log(this.filterOptions);
        const pagamentoLoteIds = isTodosOsLotes
          ?  (await conciliacaoClient.pagamentoLote.getPagamentoLotesPage({pagamentoId: this.pagamentoId, prestadorId: this.getPagamentoById?.prestadorId, pageSize: 1000}))?.data
                .filter(pagamentoLote => pagamentoLote.acoes.includes('ConciliarAutomaticamente'))
                .map(pagamentoLote => pagamentoLote.id)
          : this.selectedLotesIds

        const command = {
          data: pagamentoLoteIds.map(pagamentoLoteId => {
            return  {
              pagamentoLoteId: pagamentoLoteId,
              limparConciliacaoGuias: true,
              limparConciliacaoItens: true
            }
          })
        }

        await conciliacaoClient.conciliacaoExecucao.createConciliacaoExecucaoBatch(command)

        this.selectedLotes = []
        console.log(this.filterOptions);
        this.$asyncComputed.getPagamentoById.update()
        this.$asyncComputed.getPagamentoLotesPage.update()
      } catch (error) {
        const modalParams = {
          type: 'error',
          title: 'Erro ao enviar lotes para conciliação automática',
          btConfirm: {
            name: 'Ok',
            show: true,
            color: 'primary'
          }
        }

        this.$store.commit('confirmMessage/showConfirmMessage', modalParams)
      }
    },
    async handleBaixarPlanilhaClick () {
      try {
        const blob = await conciliacaoClient.pagamento.downloadPagamentoPlanilhaResultados(this.$props.pagamentoId)
        const href = URL.createObjectURL(blob)

        // https://stackoverflow.com/questions/43912862/axios-expose-response-headers-content-disposition
        // Para ler o nome do arquivo gerado pelo back, é preciso alterar a API para expor um header
        const filename = `Planilha de resultados-${new Date().getTime()}.xlsx`

        const link = document.createElement('a')
        link.href = href
        link.setAttribute('download', filename)
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        URL.revokeObjectURL(href)
      } catch (error) {
        window.alert('Erro ao baixar planilha')
      }
    },
    async handleQuitarPagamentoClick (quitar) {
      try {
        const data = {
          data: [
            {
              pagamentoId: this.$props.pagamentoId,
              quitado: quitar
            }
          ]
        }
        await conciliacaoClient.pagamento.updatePagamentoQuitacao(data)
        this.$asyncComputed.getPagamentoById.update()
      } catch (error) {
        window.alert('Erro ao quitar pagamento')
      }
    },
    async handleDesconciliar ( isTodosOsLotes) {
      try {
        const pagamentoId = this.pagamentoId
        const pageSize = 10000
        const pagamentoLoteIds = isTodosOsLotes
          ? (await conciliacaoClient.pagamentoLote.getPagamentoLotesPage({ pagamentoId, pageSize })).data
            .filter(lote => lote.acoes.includes('Desconciliar'))
            .map(lote => lote.id)
          : this.selectedLoteIds

        const command = {
          pagamentoId,
          data: pagamentoLoteIds.map(pagamentoLoteId => ({ pagamentoLoteId }))
        }

        await conciliacaoClient.pagamento.desconciliar(command)

        this.selectedLotes = []
        console.log(this.filterOptions);
        this.$asyncComputed.getPagamentoById.update()
        this.$asyncComputed.getPagamentoLotesPage.update()
      } catch (error) {
        const modalParams = {
          type: 'error',
          title: 'Erro ao desconciliar lotes',

          btConfirm: {
            name: 'Ok',
            show: true,
            color: 'primary'
          }
        }

        this.$store.commit('confirmMessage/showConfirmMessage', modalParams)
      }
    },
    async handleIniciarConciliacoesManuais ( isTodosOsLotes) {
      try {
        const command = {
          pagamentoId: this.$props.pagamentoId,
          pagamentoLoteIds:  isTodosOsLotes
            ? (await conciliacaoClient.pagamentoLote.getPagamentoLotesPage({pagamentoId: this.pagamentoId, pageSize: 1000}))?.data
                .filter(pagamentoLote => pagamentoLote.acoes.includes('ConciliarManualmente'))
                .map(pagamentoLote => pagamentoLote.id)
            : this.selectedLotesIds
        }

        await conciliacaoClient.pagamentoLote.iniciarConciliacoesManuais(command)

        this.selectedLotes = []
        console.log(this.filterOptions);
        this.$asyncComputed.getPagamentoById.update()
        this.$asyncComputed.getPagamentoLotesPage.update()
      } catch {
        const modalParams = {
          type: 'error',
          title: 'Erro ao iniciar conciliação manual',

          btConfirm: {
            name: 'Ok',
            show: true,
            color: 'primary'
          }
        }

        this.$store.commit('confirmMessage/showConfirmMessage', modalParams)
      }
    },
    async handleFinalizarConciliacao ( isTodosOsLotes) {
      try {
        const command = {
          pagamentoId: this.$props.pagamentoId,
          pagamentoLoteIds:  isTodosOsLotes
            ? (await conciliacaoClient.pagamentoLote.getPagamentoLotesPage({pagamentoId: this.pagamentoId, pageSize: 1000}))?.data
                .filter(pagamentoLote => pagamentoLote.acoes.includes('FinalizarConciliacaoManual'))
                .map(pagamentoLote => pagamentoLote.id)
            : this.selectedLotesIds
        }

        await conciliacaoClient.pagamentoLote.finalizarConciliacoesManuais(command)

        this.selectedLotes = []
        console.log(this.filterOptions);
        this.$asyncComputed.getPagamentoById.update()
        this.$asyncComputed.getPagamentoLotesPage.update()
      } catch {
        const modalParams = {
          type: 'error',
          title: 'Erro ao finalizar lotes',

          btConfirm: {
            name: 'Ok',
            show: true,
            color: 'primary'
          }
        }
        this.$store.commit('confirmMessage/showConfirmMessage', modalParams)
      }
    },
    async handleAssumir (isTodosOsLotes) {
      try {
        const command = {
          pagamentoId: this.$props.pagamentoId,
          responsavelId: this.userId,
          pagamentoLoteIds:  isTodosOsLotes
            ? (await conciliacaoClient.pagamentoLote.getPagamentoLotesPage({pagamentoId: this.pagamentoId, pageSize: 1000}))?.data
                .filter(pagamentoLote => pagamentoLote.acoes.includes('AssumirComoResponsavel'))
                .map(pagamentoLote => pagamentoLote.id)
            : this.selectedLotesIds
        }

        await conciliacaoClient.pagamentoLote.updateResponsaveis(command)

        this.selectedLotes = []
        console.log(this.filterOptions);
        this.$asyncComputed.getPagamentoById.update()
        this.$asyncComputed.getPagamentoLotesPage.update()
      } catch {
        const modalParams = {
          type: 'error',
          title: 'Erro ao assumir lotes',

          btConfirm: {
            name: 'Ok',
            show: true,
            color: 'primary'
          }
        }

        this.$store.commit('confirmMessage/showConfirmMessage', modalParams)
      }
    },
    async handleLimparResponsavel (isTodosOsLotes) {
      try {
        const command = {
          pagamentoId: this.$props.pagamentoId,
          prestadorId: this.getPagamentoById?.prestadorId,
          responsavelId: null,
          pagamentoLoteIds:  isTodosOsLotes
            ? (await conciliacaoClient.pagamentoLote.getPagamentoLotesPage({pagamentoId: this.pagamentoId, prestadorId:this.prestadorId, pageSize: 1000}))?.data
                .filter(pagamentoLote => pagamentoLote.acoes.includes('RemoverResponsavel'))
                .map(pagamentoLote => pagamentoLote.id)
            : this.selectedLotesIds
        }

        await conciliacaoClient.pagamentoLote.updateResponsaveis(command)

        this.selectedLotes = []
        console.log(this.filterOptions);
        this.$asyncComputed.getPagamentoById.update()
        this.$asyncComputed.getPagamentoLotesPage.update()
      } catch {
        const modalParams = {
          type: 'error',
          title: 'Erro ao limpar responsáveis',

          btConfirm: {
            name: 'Ok',
            show: true,
            color: 'primary'
          }
        }

        this.$store.commit('confirmMessage/showConfirmMessage', modalParams)
      }
    },
    async handlePublicarPagamentoClick () {
      try {
        await conciliacaoClient.pagamento.publicarPagamento2(this.$props.pagamentoId)
        this.$asyncComputed.getPagamentoById.update()
        this.$asyncComputed.getPagamentoLotesPage.update()
      } catch {
        const modalParams = {
          type: 'error',
          title: 'Erro ao publicar pagamento',

          btConfirm: {
            name: 'Ok',
            show: true,
            color: 'primary'
          }
        }

        this.$store.commit('confirmMessage/showConfirmMessage', modalParams)
      }
    },
    handleSelectLote (pagamentoLote) {
      this.selectedLotes.push(pagamentoLote)
    },
    handleDeselectLote (pagamentoLote) {
      this.selectedLotes = this.selectedLotes.filter(lote => lote.id !== pagamentoLote.id)
    },
    selectAllLotes () {
      this.selectedLotes = this.getPagamentoLotesPage.data
    },
    deselectAllLotes () {
      this.selectedLotes = []
    },
    handleClearFilter () {
      this.filterOptions = {
        status: '',
        numeroLote: '',
        numeroProtocolo: ''
      }
    },
    handleChangeFilter (newValuefilterOptions) {
      this.filterOptions = { ...this.filterOptions, ...newValuefilterOptions }
    },
    handleTabChange (key) {
      this.selectedTabKey = key
      this.filterOptions = Object.assign({}, this.filterOptions, this.tabs.find(tab => tab.key === key)?.query || {})
      this.filterOptions.tab =  this.tabs.find(tab => tab.key === key)?.query || {}
    },
    handleNavigateToBaixa () {
      this.$router.push({ name: 'pagamentoBaixa', params: { pagamentoId: this.pagamentoId } })
    },
    async handleConcluirPagamento (geraGlosa) {
      const command = {
        geraGlosa: Boolean(geraGlosa)
      }

      await conciliacaoClient.pagamento.concluirPagamento(this.pagamentoId, command)

      this.$asyncComputed.getPagamentoById.update()
    },
    async handleEncerrarValidacaoClick (justificativa) {
      const data = {
        message: justificativa
      }
      try {
        await conciliacaoClient.pagamento.encerrarValidacao(this.$props.pagamentoId, data)
        this.$asyncComputed.getPagamentoById.update()
        this.$asyncComputed.getPagamentoLotesPage.update()
      } catch (error) {
        const paramModal = {
          type: "error",
          title: "Encerrar validação",
          message: `Erro ao encerrar validações. <br/>${error}`,
          btConfirm: { name: "Fechar", show: true },
        };
        this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
      }
    },
    async handleUpdateToFaturamentoNaoIdentificadoClick () {
      try {
        await conciliacaoClient.pagamento.updatePagamentoStatus(this.$props.pagamentoId, { status: 'faturamentoNaoIdentificado' })
        this.$asyncComputed.getPagamentoById.update()
        this.$asyncComputed.getPagamentoLotesPage.update()
      } catch (error) {
        const paramModal = {
          type: "error",
          title: "Faturamento não identificado",
          message: `Erro ao atualizar para faturamento não identificado. <br/>${error}`,
          btConfirm: { name: "Fechar", show: true },
        };
        this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
      }
    },
    async handleUpdateToValoresDivergentesClick () {
      try {
        await conciliacaoClient.pagamento.updatePagamentoStatus(this.$props.pagamentoId, { status: 'valoresDivergentes' })
        this.$asyncComputed.getPagamentoById.update()
        this.$asyncComputed.getPagamentoLotesPage.update()
      } catch (error) {
        const paramModal = {
          type: "error",
          title: "Valores divergentes",
          message: `Erro ao atualizar para valores divergentes. <br/>${error}`,
          btConfirm: { name: "Fechar", show: true },
        };
        this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
      }
    },
    openConclusaoDialog () {
      const modalParamsDefault = {
        type: 'warning',
        title: 'Concluir conciliação do pagamento',
        message: this.configGeraGlosa
          ? 'Conciliação abaixo de 100%, não será gerada glosa para itens de faturamento não conciliados.'
          : undefined,
        callback: async () => await this.handleConcluirPagamento(false),
        btConfirm: {
          name: 'Concluir',
          show: true,
          color: 'primary'
        },
        btCancel: {
          name: 'Cancelar',
          show: true
        }
      }

      const modalParamsGlosaFake = {
        type: 'warning',
        title: 'Concluir conciliação do pagamento',
        message: 'Deseja gerar glosa para itens de faturamento não conciliados?',
        callback: () => this.handleConcluirPagamento(true),
        btConfirm: {
          name: 'Concluir e gerar glosa',
          show: true,
          color: 'primary'
        },
        btExtra: {
          name: 'Concluir sem gerar glosa',
          show: true,
          color: 'secondary',
          callback: async () => await this.handleConcluirPagamento(false)
        },
        btCancel: {
          name: 'Cancelar',
          show: true
        }
      }

      const modalParams = this.configGeraGlosa && this.isPagamentoConciliado
        ? { ...modalParamsGlosaFake }
        : { ...modalParamsDefault }

      this.$store.commit('confirmMessage/showConfirmMessage', modalParams)
    },
    modalConciliacaoAutomatica () {
      const paramModal = {
        type: "warning",
        title: "Conciliação automática",
        message: "Todos os lotes serão enviados para conciliação automática e todas as guias e itens conciliados serão desconciliados.",
        callback: () => this.handleConciliacaoAutomaticaBatchClick(true),
        btConfirm: { name: "Confirmar", show: true },
        btCancel: { name: "Cancelar", show: true },
      };
      this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
    },
    modalDeletaConciliacao () {
      const paramModal = {
        type: "warning",
        title: "Deletar conciliação",
        message: "Essa ação desassocia todas as guias e desconcilia todos os itens de todos os lotes.",
        callback: () => this.handleDesconciliar(true),
        btConfirm: { name: "Confirmar", show: true },
        btCancel: { name: "Cancelar", show: true },
      };
      this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
    }
  },
  computed: {
    paginationLength () {
      return Math.ceil(this.getPagamentoLotesPage?.totalSize / 10) || 0
    },
    hasPagination () {
      return this.getPagamentoLotesPage?.totalSize / 10 > 1
    },
    totalLotes () {
      return this.getPagamentoLotesPage?.totalSize || 0
    },
    baixaDisabled () {
      return this.getPagamentoById.valorPago <= this.getPagamentoById.valorPagoConciliado
    },
    selectedLotesIds () {
      return this.selectedLotes.map(lote => lote.id)
    },
    isStatusCliente () {
      const statusCliente = ['conciliacaoAutomaticaCliente', 'conciliacaoManualCliente', 'conclusaoPendente', 'gerandoArquivos', 'concluido']

      return statusCliente.includes(this.getPagamentoById?.status)
    },
    isUsuarioTradimus () {
      const usuarioTradimus = sessionStorageClient.getItem('userData')?.['UsuarioTradimus']
      return usuarioTradimus
    },
    canDoActions () {
      const conclusaoStatus = ['gerandoArquivos', 'concluido']

      return !conclusaoStatus.includes(this.getPagamentoById?.status)
    },
    configGeraGlosa () {
      return this.getConfiguration?.config?.ItensNaoDemonstradosGeraGlosa === 'true'
    },
    canConcluirPagamento () {
      return this.getPagamentoById?.status === 'conclusaoPendente'
    },
    isPagamentoConciliado () {
      return this.getPagamentoById?.percentualProducaoConciliadoValor === 100 //&& this.getPagamentoById?.percentualConciliadoQuantidade
    },
    isPagamentoComDiferencaValor () {
      return this.getPagamentoById?.pagamentoComDiferencaValor
    },
    statusPublicacaoPendente () {
      return this.getPagamentoById?.status === 'publicacaoPendente'
    },
    percentuaisInconsistentes () {
      const percentualPagamentoInconsistente =
        this.getPagamentoById?.percentualConciliadoQuantidade > 100 ||
        this.getPagamentoById?.percentualConciliadoValor > 100

      return percentualPagamentoInconsistente || this.getPagamentoById?.percentualGuiaInconsistente || this.getPagamentoById?.percentualLoteInconsistente
    },
    canPublicarPagamento () {
      return this.statusPublicacaoPendente && !this.percentuaisInconsistentes && !this.isPagamentoComDiferencaValor
    },
    acoesDeLotes () {
      return [
        {
          title: 'Executar conciliação automática de todos os lotes',
          onClick: () => this.modalConciliacaoAutomatica()
        },
        {
          title: 'Deletar toda conciliação de todos os lotes',
          onClick: () => this.modalDeletaConciliacao()
        },
        {
          title: 'Iniciar conciliação manual de todos os lotes',
          onClick: ( isTodosOsLotes) => this.handleIniciarConciliacoesManuais(isTodosOsLotes)
        },
        {
          title: 'Assumir todos os lotes',
          onClick: ( isTodosOsLotes) => this.handleAssumir( isTodosOsLotes)
        },
        {
          title: 'Limpar responsável de todos os lotes',
          onClick: ( isTodosOsLotes) => this.handleLimparResponsavel( isTodosOsLotes)
        },
        {
          title: 'Finalizar conciliação de todos os lotes',
          onClick: ( isTodosOsLotes) => this.handleFinalizarConciliacao(isTodosOsLotes)
        }
      ]
    }
  },
  asyncComputed: {
    getPagamentoById: {
      get () {
        const params = {
          includePrestador: true,
          includeOperadoraAns: true,
          includePagamentoLotes: true
        }

        return conciliacaoClient.pagamento.getPagamentoById(this.pagamentoId, params)
      }
    },
    getPagamentoLotesPage: {
      get () {
        const params = {
          pagamentoId: this.pagamentoId,
          prestadorId: this.getPagamentoById?.prestadorId,
          pageNumber: this.page - 1,
          pageSize: 10,
          sorting: this.selectSort,
          //status: this.filterOptions.status,
          //statusIn: this.filterOptions.statusIn,
          ...this.filterOptions//.tab
        }
        return conciliacaoClient.pagamentoLote.getPagamentoLotesPage(params)
      }
    },
    getPagamentoArquivosPage: {
      get () {
        const params = {
          pagamentoId: this.pagamentoId,
          pageSize: 1000
        }
        return conciliacaoClient.pagamentoArquivo.getPagamentoArquivosPage(params)
      }
    },
    getConfiguration: {
      get () {
        const operadoraAnsId = this.getPagamentoById?.operadoraAnsId
        const prestadorId = this.getPagamentoById?.prestadorId

        if (!operadoraAnsId || !prestadorId) return

        const command = {
          operadoraAnsId,
          prestadorId,
          category: 'Conciliacao'
        }

        return conciliacaoClient.configuration.getOperadoraPrestadorConfiguration(command)
      }
    }
  },
  async mounted () {
    const signedUser = await conciliacaoClient.authentication.getSignedUser()

    if (signedUser) {
      this.userId = signedUser.id
      this.usuarioTradimus = signedUser.usuarioTradimus
    }
  }
}
</script>
